import * as React from 'react';
import style from './index.module.scss';

export const BuildInfo = () => <div className={style.buildInfo}>
    {`v${VERSION} (commit: ${COMMIT})`}
</div>;
